import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _app = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _createAppFromTemplateRequest = {};
var _createAppFromTemplateResponse = { app: '_app' };
var _createBlocksAppFromTemplateRequest = {};
var _createBlocksAppFromTemplateResponse = { app: '_app' };
var _listAppTemplatesRequest = {};
var _listAppTemplatesResponse = {};
function resolveWixDevcenterAppsTemplatesV1AppTemplatesServiceUrl(opts) {
    var domainToMappings = {
        'dev._base_domain_': [
            {
                srcPath: '/app-templates-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/app-templates-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Create app from template */
export function createAppFromTemplate(payload) {
    var _a = serializer(_createAppFromTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createAppFromTemplateResponse, {
        _app: _app,
    }).fromJSON;
    function __createAppFromTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_template',
            method: 'POST',
            methodFqn: 'wix.devcenter.apps.templates.v1.AppTemplatesService.CreateAppFromTemplate',
            url: resolveWixDevcenterAppsTemplatesV1AppTemplatesServiceUrl({
                protoPath: '/v1/create-app-from-template',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createAppFromTemplate.fromReq = fromReq;
    __createAppFromTemplate.__isAmbassador = true;
    return __createAppFromTemplate;
}
/** Create blocks app from template */
export function createBlocksAppFromTemplate(payload) {
    var _a = serializer(_createBlocksAppFromTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBlocksAppFromTemplateResponse, { _app: _app }).fromJSON;
    function __createBlocksAppFromTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_template',
            method: 'POST',
            methodFqn: 'wix.devcenter.apps.templates.v1.AppTemplatesService.CreateBlocksAppFromTemplate',
            url: resolveWixDevcenterAppsTemplatesV1AppTemplatesServiceUrl({
                protoPath: '/v1/create-blocks-app-from-template',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBlocksAppFromTemplate.fromReq = fromReq;
    __createBlocksAppFromTemplate.__isAmbassador = true;
    return __createBlocksAppFromTemplate;
}
/** List app templates */
export function listAppTemplates(payload) {
    var _a = serializer(_listAppTemplatesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAppTemplatesResponse, {}).fromJSON;
    function __listAppTemplates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.apps.v1.app_template',
            method: 'GET',
            methodFqn: 'wix.devcenter.apps.templates.v1.AppTemplatesService.ListAppTemplates',
            url: resolveWixDevcenterAppsTemplatesV1AppTemplatesServiceUrl({
                protoPath: '/v1/app-templates',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAppTemplates.fromReq = fromReq;
    __listAppTemplates.__isAmbassador = true;
    return __listAppTemplates;
}
//# sourceMappingURL=http.impl.js.map